import { Link } from "react-router-dom";
import logo from "assets/mysher_logo.svg";
import footerBg from "assets/footer_bg.png";
import { AVIARY_DIRECTIONS_URL } from "components/LocationMap";

const EXPLORE_LINKS = [
  { label: "Store", to: "/store" },
  { label: "Birds", to: "/birds" },
  { label: "Videos", to: "/videos" },
  { label: "Blog", to: "/blog" },
];

const Footer = () => (
  <footer className="relative bg-[#f1ebe2]">
    <img
      src={footerBg}
      alt=""
      aria-hidden="true"
      className="block h-[320px] w-full select-none object-cover object-bottom md:h-auto"
    />

    <div className="container relative z-1 -mt-[150px] md:-mt-[420px]">
      <div className="mx-auto max-w-5xl rounded-3xl bg-brand-dark p-8 text-white shadow-2xl md:p-12">
        <div className="grid grid-cols-1 gap-10 border-b border-white/10 pb-10 md:grid-cols-4 md:gap-12 md:pb-12">
          <div className="md:col-span-2">
            <img src={logo} alt="Mysher Aviary" className="mb-4 h-12 w-auto" />
            <p className="max-w-sm text-sm leading-relaxed text-white/60">
              A family-owned bird sanctuary in Baesa, Quezon City — raising
              healthy, hand-raised parrots with 25+ years of dedication and love.
            </p>
          </div>

          <div>
            <h4 className="mb-4 text-[11px] font-bold uppercase tracking-[0.2em] text-brand-amber">
              Explore
            </h4>
            <ul className="space-y-3 text-sm text-white/70">
              {EXPLORE_LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="transition-opacity hover:opacity-60">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-[11px] font-bold uppercase tracking-[0.2em] text-brand-amber">
              Visit Us
            </h4>
            <p className="mb-4 text-sm leading-relaxed text-white/70">
              Jojo Street, Baesa
              <br />
              Quezon City, 1106 Philippines
            </p>
            <div className="flex flex-col gap-2 text-sm font-semibold">
              <a
                href={AVIARY_DIRECTIONS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-brand-amber transition-opacity hover:opacity-70"
              >
                Get Directions ↗
              </a>
              <Link to="/contact" className="text-white/70 transition-opacity hover:opacity-60">
                Contact Us
              </Link>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 pt-6 text-xs text-white/40 md:flex-row">
          <p>© {new Date().getFullYear()} Mysher Aviary. All rights reserved.</p>
          <p>Raised with love in the Philippines 🇵🇭</p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
